import {NgModule} from '@angular/core';
import {FilesDragDropDirective} from '../project-misc/directives/drag-drop.directive';
import {PasteFileDirective} from '../project-misc/directives/pasteFile.directive';

@NgModule({
  declarations: [
    FilesDragDropDirective,
    PasteFileDirective
  ],
  exports: [
    FilesDragDropDirective,
    PasteFileDirective
  ]
})
export class FilesMiscModule {
}
